import { includes } from 'ramda';

const lang = window.location.pathname.split('/')[1];

/**
 * See more information about defined languages
 * https://prj.adyax.com/projects/valeo-service-drupal-8-reworking/wiki/Oxalide_Dev_environment
 * @param {*} language
 */
export const getCountryCodes = (language) => {
  switch (language) {
    // Great Britain.
    case 'en-uk':
      return {
        articleCountry: 'GB',
        langTechAssist: 'en',
        lang: 'en',
        country: 'Great Britain',
      };
    // France.
    case 'fr':
      return {
        articleCountry: 'FR',
        langTechAssist: 'fr',
        lang: 'fr',
        country: 'France',
      };
    // USA.
    case 'en-us':
      return {
        articleCountry: 'US',
        langTechAssist: 'en',
        lang: 'en',
        country: 'USA',
      };
    // Germany.
    case 'de':
      return {
        articleCountry: 'DE',
        langTechAssist: 'de',
        lang: 'de',
        country: 'Germany',
      };
    // Italy.
    case 'it':
      return {
        articleCountry: 'IT',
        langTechAssist: 'it',
        lang: 'it',
        country: 'Italy',
      };
    // India.
    case 'en-in':
      return {
        articleCountry: 'IN',
        langTechAssist: 'en',
        lang: 'en',
        country: 'India',
      };
    // Belgium.
    case 'be-nl':
      return {
        articleCountry: 'NL',
        langTechAssist: 'nl',
        lang: 'nl',
        country: 'Belgium',
      };
    case 'be-fr':
      return {
        articleCountry: 'NL',
        langTechAssist: 'fr',
        lang: 'fr',
        country: 'Belgium',
      };
    // Spain.
    case 'es':
      return {
        articleCountry: 'ES',
        langTechAssist: 'es',
        lang: 'es',
        country: 'Spain',
      };
    // Russia.
    case 'ru':
      return {
        articleCountry: 'RU',
        langTechAssist: 'ru',
        lang: 'ru',
        country: 'Russia',
      };
    // Greece
    case 'el':
      return {
        articleCountry: 'GR',
        langTechAssist: 'el',
        lang: 'el',
        country: 'Greece',
      };
    // Portugal.
    case 'pt-pt':
      return {
        articleCountry: 'PT',
        langTechAssist: 'pt',
        lang: 'pt',
        country: 'Portugal',
      };
    // Netherlands.
    case 'nl':
      return {
        articleCountry: 'NL',
        langTechAssist: 'nl',
        lang: 'nl',
        country: 'Netherlands',
      };
    // Poland.
    case 'pl':
      return {
        articleCountry: 'PL',
        langTechAssist: 'pl',
        lang: 'pl',
        country: 'Poland',
      };
    // Turkey.
    case 'tr':
      return {
        articleCountry: 'TR',
        langTechAssist: 'tr',
        lang: 'tr',
        country: 'Turkey',
      };
    // UAE.
    case 'en-ae':
      return {
        articleCountry: 'TR',
        langTechAssist: 'en',
        lang: 'en',
        country: 'UAE',
      };
    // Argentina.
    case 'es-ar':
      return {
        articleCountry: 'AR',
        langTechAssist: 'es',
        lang: 'es',
        country: 'Argentina',
      };
    // Brazil.
    case 'pt-br':
      return {
        articleCountry: 'BR',
        langTechAssist: 'pt',
        lang: 'qc',
        country: 'Brazil',
        initialSearchTab: 'reference',
      };
    case 'es-br':
      return {
        articleCountry: 'AR',
        langTechAssist: 'es',
        lang: 'es',
        country: 'Brazil',
      };
    // China.
    case 'zh-hans':
      return {
        articleCountry: 'CN',
        langTechAssist: 'zh-hans',
        lang: 'zh',
        country: 'China',
      };
    // Thailand.
    case 'en-th':
      return {
        articleCountry: '.com',
        langTechAssist: 'en',
        lang: 'en',
        country: 'Thailand',
      };
    // Mexico.
    case 'es-mx':
      return {
        articleCountry: 'MX',
        langTechAssist: 'es',
        lang: 'qd',
        country: 'Mexico',
      };
    // .com domain.
    case 'fr-com':
      return {
        articleCountry: '.com',
        langTechAssist: 'fr',
        lang: 'fr',
        country: 'fr-com',
      };
    case 'en-com':
      return {
        articleCountry: '.com',
        langTechAssist: 'en',
        lang: 'en',
        country: 'en-com',
      };
    default:
      return {
        articleCountry: 'GB',
        langTechAssist: 'en',
        lang: 'en',
        country: 'Great Britain',
      };
  }
};

const countrySelectorDomains = ['en-com', 'fr-com', 'en-th'];

export const isGlobalSite = includes(lang, countrySelectorDomains);
export const currentLanguage = lang;
export const langCode = getCountryCodes(lang).lang;
export const langCodeTA = getCountryCodes(lang).langTechAssist;
export const currentCountry = getCountryCodes(lang).country;
export const articleCountry = getCountryCodes(lang).articleCountry;
export const initialSearchTab = getCountryCodes(lang).initialSearchTab || 'car';



// WEBPACK FOOTER //
// ./src/utils/currentLanguage/currentLanguage.js